import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Loader2, Lock } from "lucide-react";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/admin/login", { email, password });
      localStorage.setItem("admin_token", data.token);
      navigate("/admin");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Invalid credentials");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="admin-login-page" className="min-h-screen flex items-center justify-center px-6">
      <form onSubmit={submit} className="w-full max-w-sm border-2 border-[#0B0C0E] bg-white p-10">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-10 h-10 bg-[#0B0C0E] flex items-center justify-center font-black text-[#FACC15]">14</div>
          <div>
            <div className="overline">14 Acres</div>
            <div className="font-display font-black text-2xl text-[#0B0C0E] uppercase">Admin</div>
          </div>
        </div>

        <label className="overline mb-2 block">Email</label>
        <input
          value={email} onChange={(e) => setEmail(e.target.value)} type="email" required
          className="w-full bg-white border border-[#C6C3B5] focus:border-[#0B0C0E] outline-none px-4 py-3 text-[#0B0C0E] text-sm"
          data-testid="admin-email"
        />
        <label className="overline mt-4 mb-2 block">Password</label>
        <input
          value={password} onChange={(e) => setPassword(e.target.value)} type="password" required
          className="w-full bg-white border border-[#C6C3B5] focus:border-[#0B0C0E] outline-none px-4 py-3 text-[#0B0C0E] text-sm"
          data-testid="admin-password"
        />

        <button
          type="submit" disabled={loading}
          className="mt-8 w-full bg-[#0B0C0E] hover:bg-black disabled:opacity-60 text-white font-bold py-3 uppercase tracking-wide inline-flex items-center justify-center gap-2 border-l-4 border-[#FACC15]"
          data-testid="admin-login-submit"
        >
          {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : <Lock className="w-4 h-4" />} Sign In
        </button>
      </form>
    </div>
  );
}
